import { createApp } from 'vue'
import ProductOverview from '@/vue_components/product-overview/product-overview.vue'
import SearchHistoryService from '@/services/searchHistoryService'


document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('product-overview')
       if (!el) return


    SearchHistoryService.create();
    createApp(ProductOverview, { })
        .mount(el)
})

